module.exports = __webpack_public_path__ + "static/farewell_card-5d5f4c61ffb2a40bf39d2ce3d6fa8de0.png";